<template>
  <div>
    <div v-if="topic">
      <article class="media">
        <figure class="media-left" v-if="topic.image_url">
          <h2 class="title is-2 is-pulled-left" style="margin-top:8px;">
            <router-link to="/topics">
              <b-icon icon="chevron-left" size="is-small"></b-icon>
            </router-link>&nbsp;
          </h2>
          <figure class="image is-64x64 is-pulled-left">
            <img @error="imageError" :src="topic.image_url" :alt="topic.name">
          </figure>
        </figure>
        <div class="media-content">
          <div class="content">
            <h4 class="title is-4 heading-top-margin">{{topic.name}}</h4>
            <p
              class="subtitle is-6"
            >{{topic.category ? topic.category : 'No Category'}} - {{topic.slug}}</p>
          </div>
        </div>
      </article>
      <hr>
      <div class="columns" v-if="editableTopic">
        <div class="column">
          <!-- mobile ame -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Name that appears on the mobile app navigation"
                dashed
                type="is-dark"
              >Mobile Name</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableTopic.name">
            </div>
          </div>
          <!-- web name -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Name that appears on the web navigation"
                dashed
                type="is-dark"
              >Web Name</b-tooltip>&nbsp;
              <a class="is-size-7" @click.prevent="copyName">Copy from Name</a>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableTopic.web_name">
            </div>
          </div>
          <!-- category -->
          <div class="field" label="Category">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Category item is grouped into on the web mega menu"
                dashed
                type="is-dark"
              >Category</b-tooltip>
            </label>
            <b-select placeholder="Select a category" v-model="editableTopic.category" expanded>
              <option
                v-for="option in editableTopic.possible_categories"
                :value="option"
                :key="option"
              >{{ option }}</option>
            </b-select>
          </div>
          <!-- weight -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Weight of the item fixtures"
                dashed
                type="is-dark"
              >Weight</b-tooltip>
            </label>
            <b-select placeholder="Select a weight" v-model="editableTopic.feed_weight" expanded>
              <option
                v-for="option in possible_weight_values"
                :value="option"
                :key="option"
              >{{ getWeightNames(option) }}</option>
            </b-select>
          </div>
          <!-- featured id -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Position of the item on the top web nav. 1-12 for homepage 13-19 for sports level pages"
                dashed
                type="is-dark"
              >Web Position</b-tooltip>
            </label>
            <b-select placeholder="Select a position" v-model="editableTopic.featured_id" expanded>
              <option
                v-for="option in possible_featured_ids"
                :value="option"
                :key="option"
              >{{ getNamesOfFriends(option, 'featured_id') }}</option>
            </b-select>
          </div>
          <!-- web quick link position -->
          <div class="field" label="Web Quick Link Position">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Position of the item on the mega menu. Whithin it's respective category"
                dashed
                type="is-dark"
              >Web Quick Link Position</b-tooltip>
            </label>
            <b-select placeholder="Select a position" v-model="editableTopic.web_position" expanded>
              <option
                v-for="option in possible_web_positions"
                :value="option"
                :key="option"
              >{{ getNamesOfFriends(option, 'web_position') }}</option>
            </b-select>
          </div>
          <!-- app position -->
          <div class="field" label="App Position">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Position of the item on the app navigation"
                dashed
                type="is-dark"
              >App Position</b-tooltip>
            </label>
            <b-select placeholder="Select a position" v-model="editableTopic.position" expanded>
              <option
                v-for="option in possible_positions"
                :value="option"
                :key="option"
              >{{ getNamesOfFriends(option, 'position') }}</option>
            </b-select>
          </div>
        </div>
        <div class="column">
          <div class="columns is-multiline">
            <div class="column is-one-third">
              <!-- enabled -->
              <div class="field">
                <label class="label">
                  <b-tooltip label="This menu is enabled and visible" dashed type="is-dark">Enabled</b-tooltip>
                </label>
                <b-switch v-model="editableTopic.enabled" type="is-success"></b-switch>
              </div>
            </div>
            <div class="column is-one-third">
              <!-- app visible -->
              <div class="field">
                <label class="label">
                  <b-tooltip
                    label="This menu is visible on the mobile apps"
                    dashed
                    type="is-dark"
                  >Visible on Apps</b-tooltip>
                </label>
                <b-switch v-model="editableTopic.visible" type="is-success"></b-switch>
              </div>
            </div>
            <div class="column is-one-third">
              <!-- web visible -->
              <div class="field">
                <label class="label">
                  <b-tooltip
                    label="This menu is visible on the website navigation"
                    dashed
                    type="is-dark"
                  >Visible on Web</b-tooltip>
                </label>
                <b-switch v-model="editableTopic.web_visible" type="is-success"></b-switch>
              </div>
            </div>
            <div class="column is-one-third">
              <!-- external sharing -->
              <div class="field">
                <label class="label">
                  <b-tooltip
                    label="This tournament's data will be accessible to third parties, such as DStv.com"
                    dashed
                    type="is-dark"
                  >Share Externally</b-tooltip>
                </label>
                <b-switch v-model="editableTopic.share_externally" type="is-success"></b-switch>
              </div>
            </div>
          </div>
          <!-- hidden_tabs -->
          <div class="field">
            <hidden-tabs-manager
              :sport="editableTopic.sport"
              :hiddenTabs="editableTopic.hidden_tabs"
              @updated="hiddenTabsUpdated"
            ></hidden-tabs-manager>
          </div>
          <!-- save button -->
          <div class="field">
            <button @click="updateTopic" class="button is-primary">Update Details</button>
          </div>
        </div>
      </div>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import HiddenTabsManager from "@/components/Hidden-Tabs-Manager";
import { SET_TOPIC } from "@/store/mutations";
import {
  GET_TOPIC,
  GET_ALL_TOPIC_WEIGHTS,
  UPDATE_TOPIC
} from "@/store/actions";

export default {
  name: "topic",
  components: {
    Loading,
    HiddenTabsManager
  },
  data() {
    return {
      editableTopic: null,
      possible_featured_ids: Array.from(new Array(19), (x, i) => i + 1),
      possible_positions: Array.from(new Array(99), (x, i) => i + 1),
      possible_web_positions: Array.from(new Array(60), (x, i) => i + 1),
      possible_weight_values: Array.from(new Array(61), (x, i) => i)
    };
  },
  mounted() {
    if (!this.topic || this.topic.id !== this.topicId) {
      this.getTopic();
    } else {
      this.editableTopic = { ...this.topic };
    }

    if (!this.weights || this.weights.length <= 0) {
      this.$store.dispatch(GET_ALL_TOPIC_WEIGHTS);
    }
  },
  computed: {
    topicId() {
      return this.$route.params.id;
    },
    topic() {
      return this.$store.state.topic.item;
    },
    weights() {
      return this.$store.state.topic.weights;
    }
  },
  methods: {
    getTopic() {
      this.editableTopic = null;
      this.$store.commit(SET_TOPIC, null);
      this.$store.dispatch(GET_TOPIC, this.topicId).then(res => {
        this.editableTopic = { ...res.data };
      });
    },
    copyName() {
      this.editableTopic.web_name = this.editableTopic.name;
    },
    /**
     * Get the names of any topic that is set on a number for a particular field
     */
    getNamesOfFriends(position, field) {
      let topicNames = this.topic.friends
        .filter(x => x[field] === position)
        .map(x => x.name)
        .slice(0, 6)
        .join(", ");
      return `${position}${topicNames.length ? ` - ${topicNames}` : ""}`;
    },
    getWeightNames(weight) {
      if (!this.weights) {
        return weight;
      }

      let topicNames = this.weights
        .filter(x => x.weight === weight)
        .map(x => x.name)
        .slice(0, 6)
        .join(", ");
      return `${weight}${topicNames.length ? ` - ${topicNames}` : ""}`;
    },
    updateTopic() {
      this.$store.dispatch(UPDATE_TOPIC, { ...this.editableTopic, possible_categories: null, friends: null }).then(res => {
        if (res && res.status === 204) {
          this.$success(`Changes saved`);
        }
      });
    },
    imageError(e) {
      e.target.src = "https://www.supersport.com/images/placeholder-flag.png";
    },
    hiddenTabsUpdated(newValue) {
      this.editableTopic.hidden_tabs = newValue;
    }
  }
};
</script>

<style scoped>
.heading-top-margin {
  margin-top: 6px;
}
</style>
